export const SENDING_REQUEST = 'PERMISSIONCATEGORIESLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'PERMISSIONCATEGORIESLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'PERMISSIONCATEGORIESLIST_GETALL_FAILURE';